import { useVariant } from '@unleash/proxy-client-react';
import { useSelector } from 'react-redux';

import type { AppState } from 'types/app';
import { selectUnleashToggle } from 'selectors/features';

export const useUnleashVariant = (featureFlag: string, fallbackVariant: string = 'control') => {
  useVariant(featureFlag);

  const variantName = useSelector((state: AppState) => selectUnleashToggle(featureFlag, state))?.variant?.name;

  return variantName || fallbackVariant;
};
